<template>
  <div>
    <grain :height='height' :width='width' :type='"water"'></grain>
  </div>
</template>

<script>
import grain from './grain'
export default {
  props:{
    width:Number,
    height:Number
  },
  components:{grain}
}
</script>

<style>

</style>
